import { createRouter, createWebHistory } from 'vue-router'
import { ElMessage } from 'element-plus'
import store from '@/store'
import { getPasswordRouteRedirect } from '@/util/passwordSecurity'

const routes = [
  {
    path: '/',
    name: 'menus',
    component: () => import('@/views/menus/index.vue'),
    redirect: '/home',
    meta: { title: '菜单管理' },
    children: [
      {
        path: '/tutorialDetail',
        name: 'tutorialDetail',
        component: () => import('@/views/tutorialDetail/index.vue'),
        meta: {
          title: '教程详情',
          hidden: true
        }
      },
      {
        path: '/home',
        name: 'home',
        component: () => import('@/views/home/index.vue'),
        meta: {
          title: '首页'
        }
      },
      {
        path: '/news',
        name: 'news',
        component: () => import('@/views/news/index.vue'),
        meta: {
          title: '新闻动态'
        }
      },
      {
        path: '/policyQuery',
        name: 'policyQuery',
        component: () => import('@/views/policyQuery/index.vue'),
        meta: {
          title: '政策速递',
          hidden: false
        }
      },
      {
        path: '/technology',
        name: 'technology',
        component: () => import('@/views/technology/index.vue'),
        redirect: '/technology/policy',
        meta: {
          title: '科技创新与产业融合'
        },
        children: [
          {
            path: 'policy',
            name: 'technologyPolicy',
            component: () => import('@/views/technology/policy.vue'),
            meta: {
              title: '科技政策',
              icon: 'technology_policy_icon'
            }
          },
          {
            path: 'showcase',
            name: 'technologyShowcase',
            component: () => import('@/views/technology/showcase.vue'),
            meta: {
              title: '成果展示',
              icon: 'technology_showcase_icon'
            }
          },
          {
            path: 'demand',
            name: 'technologyDemand',
            component: () => import('@/views/technology/demand.vue'),
            meta: {
              title: '需求大厅',
              icon: 'technology_demand_icon'
            }
          },
          {
            path: 'cultivation',
            name: 'technologyCultivation',
            component: () => import('@/views/technology/cultivation.vue'),
            meta: {
              title: '企业培育',
              icon: 'technology_cultivation_icon'
            }
          }
        ]
      },
      {
        path: '/industry',
        name: 'industry',
        component: () => import('@/views/industry/index.vue'),
        redirect: '/industry/policy',
        meta: {
          title: '工业、商贸企业服务'
        },
        children: [
          {
            path: 'policy',
            name: 'industryPolicy',
            component: () => import('@/views/industry/policy.vue'),
            meta: {
              title: '政策资讯',
              icon: 'technology_policy_icon'
            }
          },
          {
            path: 'upgrade',
            name: 'industryUpgrade',
            component: () => import('@/views/industry/upgrade'),
            meta: {
              title: '企业升限升规纳统',
              icon: 'industry_upgrade_icon'
            }
          },
          {
            path: 'specialized',
            name: 'industrySpecialized',
            component: () => import('@/views/industry/specialized.vue'),
            meta: {
              title: '专精特新梯度培育',
              icon: 'industry_specialized_icon'
            }
          }
        ]
      },
      {
        path: '/rural',
        name: 'rural',
        component: () => import('@/views/rural/index.vue'),
        redirect: '/rural/policy',
        meta: {
          title: '乡村振兴科技服务'
        },
        children: [
          {
            path: 'policy',
            name: 'ruralPolicy',
            component: () => import('@/views/rural/policy'),
            meta: {
              title: '政策资讯',
              icon: 'technology_policy_icon'
            }
          },
          {
            path: 'tutorial',
            name: 'ruralTutorial',
            component: () => import('@/views/rural/tutorial'),
            meta: {
              title: '技术教程',
              icon: 'rural_tutorial_icon'
            }
          },
          {
            path: 'service',
            name: 'ruralService',
            component: () => import('@/views/rural/service'),
            meta: {
              title: '技术服务支持',
              icon: 'rural_service_icon'
            }
          }
        ]
      },
      {
        path: '/about',
        name: 'about',
        component: () => import('@/views/about/index.vue'),
        meta: {
          title: '关于我们'
        }
      },
      {
        path: '/policyDetail',
        name: 'policyDetail',
        component: () => import('@/views/policyDetail/index.vue'),
        meta: {
          title: '政策详情',
          hidden: true
        }
      },
      {
        path: '/enterpriseDemand',
        name: 'enterpriseDemand',
        component: () => import('@/views/enterpriseDemand/index.vue'),
        meta: {
          title: '企业需求提交',
          hidden: true,
          requiresAuth: true
        }
      },
      {
        path: '/agriculturalConsultation',
        name: 'agriculturalConsultation',
        component: () => import('@/views/agriculturalConsultation/index.vue'),
        meta: {
          title: '农业技术咨询',
          hidden: true,
          requiresAuth: true
        }
      },
      {
        path: '/newsDetail',
        name: 'newsDetail',
        component: () => import('@/views/newsDetail/index.vue'),
        meta: {
          title: '新闻详情',
          hidden: true
        }
      },
      {
        path: '/techDetail',
        name: 'techDetail',
        component: () => import('@/views/techDetail/index.vue'),
        meta: {
          title: '科技成果详情',
          hidden: true
        }
      },
      {
        path: '/ruralDynamic',
        name: 'ruralDynamic',
        component: () => import('@/views/ruralDynamic/index.vue'),
        meta: {
          title: '乡村振兴动态',
          hidden: true
        }
      },
      {
        path: '/activityDetail',
        name: 'activityDetail',
        component: () => import('@/views/activityDetail/index.vue'),
        meta: {
          title: '技术培训活动详情',
          hidden: true
        }
      },
      {
        path: '/ruralDynamicDetail',
        name: 'ruralDynamicDetail',
        component: () => import('@/views/ruralDynamicDetail/index.vue'),
        meta: {
          title: '乡村振兴动态详情',
          hidden: true
        }
      }
    ]
  }, {
    path: '/login',
    name: 'login',
    component: () => import('@/views/login/index.vue')
  }, {
    path: '/password-change',
    name: 'passwordChange',
    component: () => import('@/views/login/PasswordChange.vue'),
    meta: { title: '修改密码' }
  }, {
    path: '/privacyPolicy',
    name: 'privacyPolicy',
    component: () => import('@/views/privacyPolicy/index.vue')
  }, { 
    path: '/userAgreement', 
    name: 'userAgreement', 
    component: () => import('@/views/userAgreement/index.vue') 
  }, { 
    path: '/policyConditions', 
    name: 'policyConditions', 
    component: () => import('@/views/policyConditions/index.vue') 
  }, { 
    path: '/faq', 
    name: 'faq', 
    component: () => import('@/views/faq/index.vue') 
  },
  {
    path: '/admin',
    name: 'admin',
    component: () => import('@/admin/index'),
    redirect: '/admin/homeVideo',
    meta: {
      title: '后台管理系统',
    },
    children: [{
      path: 'homeVideo',
      name: 'adminHomeVideo',
      component: () => import('@/admin/homeVideo/index.vue'),
      meta: {
        title: '首页视频配置',
        hidden: true,
        icon: 'VideoCamera',
        category: '基础管理',
        categoryIcon: 'Setting'
      }
    }, {
      path: 'carousel',
      name: 'adminCarousel',
      component: () => import('@/admin/carousel/index'),
      meta: {
        title: '轮播管理',
        hidden: true,
        icon: 'Picture',
        category: '基础管理',
        categoryIcon: 'Setting'
      }
    }, {
      path: 'dictionary',
      name: 'adminDictionary',
      component: () => import('@/admin/dictionary/index'),
      meta: {
        title: '字典管理',
        hidden: true,
        icon: 'Collection',
        category: '基础管理',
        categoryIcon: 'Setting'
      }
    }, {
      path: 'user',
      name: 'adminUser',
      component: () => import('@/admin/user/index'),
      meta: {
        title: '用户管理',
        hidden: true,
        icon: 'User',
        category: '基础管理',
        categoryIcon: 'Setting'
      }
    }, {
      path: 'institution',
      name: 'adminInstitution',
      component: () => import('@/admin/institution/index'),
      meta: {
        title: '机构管理',
        hidden: true,
        icon: 'OfficeBuilding',
        category: '基础管理',
        categoryIcon: 'Setting'
      }
    }, {
      path: 'enterprise',
      name: 'adminEnterprise',
      component: () => import('@/admin/enterprise/index'),
      meta: {
        title: '企业管理',
        hidden: true,
        icon: 'School',
        category: '基础管理',
        categoryIcon: 'Setting'
      }
    }, {
      path: 'news',
      name: 'adminNews',
      component: () => import('@/admin/news/index'),
      meta: {
        title: '新闻动态管理',
        hidden: true,
        icon: 'Orange'
      }
    }, {
      path: 'policy',
      name: 'adminPolicy',
      component: () => import('@/admin/policy/index'),
      meta: {
        title: '政策速递',
        hidden: true,
        icon: 'Reading'
      }
    }, {
      path: 'contactInformation',
      name: 'adminContactInformation',
      component: () => import('@/admin/contactInformation/index'),
      meta: {
        title: '联系方式',
        hidden: true,
        icon: 'ChatLineRound',
        category: '基础管理',
        categoryIcon: 'Setting'
      }
    }, {
      path: 'feedback',
      name: 'adminFeedback',
      component: () => import('@/admin/feedback/index'),
      meta: {
        title: '意见反馈管理',
        hidden: true,
        icon: 'Message',
        category: '基础管理',
        categoryIcon: 'Setting'
      }
    }, {
      path: 'techPolicy',
      name: 'adminTechPolicy',
      component: () => import('@/admin/techPolicy/index'),
      meta: {
        title: '科技政策',
        hidden: true,
        icon: 'Reading',
        category: '科技创新与产业融合',
        categoryIcon: 'Cpu'
      }
    }, {
      path: 'tech_achievements',
      name: 'adminTechAchievements',
      component: () => import('@/admin/tech_achievements/index'),
      meta: {
        title: '科技成果管理',
        hidden: true,
        icon: 'Trophy',
        category: '科技创新与产业融合',
        categoryIcon: 'Cpu'
      }
    }, {
      path: 'enterpriseCultivation',
      name: 'adminEnterpriseCultivation',
      component: () => import('@/admin/enterpriseCultivation/index'),
      meta: {
        title: '企业培育管理',
        hidden: true,
        icon: 'School',
        category: '科技创新与产业融合',
        categoryIcon: 'Cpu'
      }
    },{
      path: 'enterpriseDemand',
      name: 'adminEnterpriseDemand',
      component: () => import('@/admin/enterpriseDemand/index'),
      meta: {
        title: '企业需求管理',
        hidden: true,
        icon: 'FolderOpened',
        category: '科技创新与产业融合',
        categoryIcon: 'Cpu'
      }
    }, {
      path: 'industrialTradePolicy',
      name: 'adminIndustrialTradePolicy',
      component: () => import('@/admin/industrialTradePolicy/index'),
      meta: {
        title: '政策资讯',
        hidden: true,
        icon: 'Reading',
        category: '工业、商贸企业服务',
        categoryIcon: 'OfficeBuilding'
      }
    }, {
      path: 'enterpriseMaterial',
      name: 'adminEnterpriseMaterial',
      component: () => import('@/admin/enterpriseUpgrading-material/index'),
      meta: {
        title: '企业升规-材料管理',
        hidden: true,
        icon: 'Box',
        category: '工业、商贸企业服务',
        categoryIcon: 'OfficeBuilding'
      }
    }, {
      path: 'enterpriseStandard',
      name: 'adminEnterpriseStandard',
      component: () => import('@/admin/enterpriseUpgrading-standard/index'),
      meta: {
        title: '企业升规-申报标准',
        hidden: true,
        icon: 'PriceTag',
        category: '工业、商贸企业服务',
        categoryIcon: 'OfficeBuilding'
      }
    }, {
      path: 'enterpriseCalendar',
      name: 'adminEnterpriseCalendar',
      component: () => import('@/admin/enterpriseUpgrading-calendar/index'),
      meta: {
        title: '企业升规-申报日历',
        hidden: true,
        icon: 'Calendar',
        category: '工业、商贸企业服务',
        categoryIcon: 'OfficeBuilding'
      }
    }, {
      path: 'enterprisePolicy',
      name: 'adminEnterprisePolicy',
      component: () => import('@/admin/enterpriseUpgrading-policy/index'),
      meta: {
        title: '企业升规-奖励政策管理',
        hidden: true,
        icon: 'Reading',
        category: '工业、商贸企业服务',
        categoryIcon: 'OfficeBuilding'
      }
    }, {
      path: 'declarationMaterials',
      name: 'adminDeclarationMaterials',
      component: () => import('@/admin/declarationMaterials/index'),
      meta: {
        title: '申报资料管理',
        hidden: true,
        icon: 'Files',
        category: '工业、商贸企业服务',
        categoryIcon: 'OfficeBuilding'
      }
    },{
      path: 'gradientCultivationSystem',
      name: 'adminGradientCultivationSystem',
      component: () => import('@/admin/ gradientCultivationSystem/index.vue'),
      meta: {
        title: '梯度培育体系',
        hidden: true,
        icon: 'Stopwatch',
        category: '工业、商贸企业服务',
        categoryIcon: 'OfficeBuilding'
      }
    }, {
      path: 'interpretationCorePolicies',
      name: 'adminInterpretationCorePolicies',
      component: () => import('@/admin/interpretationCorePolicies/index'),
      meta: {
        title: '核心政策解读',
        hidden: true,
        icon: 'Document',
        category: '工业、商贸企业服务',
        categoryIcon: 'OfficeBuilding'
      }
    }, {
      path: 'declarationGuidelinesConsultation',
      name: 'adminDeclarationGuidelinesConsultation',
      component: () => import('@/admin/declarationGuidelinesConsultation/index'),
      meta: {
        title: '申报指引与咨询',
        hidden: true,
        icon: 'HelpFilled',
        category: '工业、商贸企业服务',
        categoryIcon: 'OfficeBuilding'
      }
    }, {
      path: 'ruralPolicyConsult',
      name: 'adminRuralPolicyConsult',
      component: () => import('@/admin/ruralPolicyConsult/index'),
      meta: {
        title: '政策资讯',
        hidden: true,
        icon: 'Reading',
        category: '乡村振兴科技服务',
        categoryIcon: 'Cherry'
      }
    },{
      path: 'rural',
      name: 'adminRural',
      component: () => import('@/admin/rural/index'),
      meta: {
        title: '乡村振兴动态管理',
        hidden: true,
        icon: 'Clock',
        category: '乡村振兴科技服务',
        categoryIcon: 'Cherry'
      }
    }, {
      path: 'agriculturalConsult',
      name: 'adminAgriculturalConsult',
      component: () => import('@/admin/agriculturalConsult/index'),
      meta: {
        title: '农业技术咨询管理',
        hidden: true,
        icon: 'Folder',
        category: '乡村振兴科技服务',
        categoryIcon: 'Cherry'
      }
    }, {
      path: 'tech',
      name: 'adminTech',
      component: () => import('@/admin/tech/index'),
      meta: {
        title: '技术教程视频管理',
        hidden: true,
        icon: 'VideoCamera',
        category: '乡村振兴科技服务',
        categoryIcon: 'Cherry'
      }
    }, {
      path: 'technicalTrainingActivities',
      name: 'adminTechnicalTrainingActivities',
      component: () => import('@/admin/technicalTrainingActivities/index'),
      meta: {
        title: '技术培训活动',
        hidden: true,
        icon: 'VideoCamera',
        category: '乡村振兴科技服务',
        categoryIcon: 'Cherry'
      }
    }, {
      path: 'onlineConsultation',
      name: 'adminOnlineConsultation',
      component: () => import('@/admin/onlineConsultation/index'),
      meta: {
        title: '在线咨询',
        hidden: true,
        icon: 'Service'
      }
    }
  ]
}
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach(async (to) => {
  if (to.meta.requiresAuth && !localStorage.getItem('accessToken')) {
    ElMessage.warning('请先登录后再提交或上传资料')
    return { path: '/login', query: { redirect: to.fullPath } }
  }

  if (!store.getters.userInfo && localStorage.getItem('accessToken')) {
    await store.dispatch('fetchUserInfo')
  }

  const redirect = getPasswordRouteRedirect(Boolean(localStorage.getItem('accessToken')), store.getters.userInfo, to.path)
  if (redirect) return redirect
  if (!to.path.startsWith('/admin')) return true

  return store.getters.isAdmin ? true : '/home'
})

router.onError((error) => {
  const msg = error?.message || String(error || '')
  if (/Loading chunk [\d]+ failed|Failed to fetch dynamically imported module|Importing a module script failed/i.test(msg)) {
    ElMessage.error('页面资源加载失败，请强制刷新后重试')
  }
})

export default router
